export default __webpack_public_path__ + "static/media/Bare Soil.c68ae73b.png";